// Models
PJQ.models.notificationSettings = {};

PJQ.models.notificationSettings.NotificationSetting = PJQ.models.BaseModel.extend();

PJQ.models.notificationSettings.ContactNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.ProjectsNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();

PJQ.models.notificationSettings.MessagingNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.PrivateMessagingNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.BidFormNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.DrawingNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.AttachmentNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.ProjectContactNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.RFINotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.DailyReportNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.PunchListNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.ActionItemNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.SubmittalNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.ScheduleNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.MeetingNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.PayableInvoiceNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();
PJQ.models.notificationSettings.CommitmentNotifications = PJQ.models.notificationSettings.NotificationSetting.extend();

PJQ.models.notificationSettings.NotificationSettings = PJQ.models.BaseModel.extend({
	idAttribute: "notificationSettingsId",
	endpoint: function () {
		if (this.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'notificationsettings',
					value: this.id
				}
			]);
		}
		else if (this.get('id') != null && this.get('projectId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'contacts',
					value: this.get('id')
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}
		else if (this.get('id') < 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users',
					value: this.get('id')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}
		else if (this.get('id') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.get('id')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}
		else if (this.get('userTypeId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usertypes',
					value: this.get('userTypeId')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId') > 0 ? this.get('projectId') : null
			},
			{
				endpoint: 'notificationsettings'
			}
		]);
	},
	hasNotificationSetting: function (notificationSetting, options = {}) {
		let result = null;
		let splitNS = _.bind(function (setting) {
			let parts = setting.split('.'),
				size = _.size(parts),
				stack = this,
				settingsResult = false;
			_.each(parts, function (part, index) {
				if (stack == null) {
					return;
				}

				if (index + 1 === size) {
					settingsResult = stack.get(part) === true;
				}
				else {
					stack = stack[part];
				}
			}, this);
			return settingsResult;
		}, this);
		if (PJQ.helpers.objectHelpers.refinedType(notificationSetting) === 'array') {
			_.each(notificationSetting, function (ns) {
				if (options.or) {
					result = splitNS(ns) || (result == null ? false : result);
				}
				else {
					result = splitNS(ns) && (result == null ? true : result);
				}
			});
		}
		else {
			result = splitNS(notificationSetting);
		}
		return result == null ? false : result;
	},
	parse: function (model) {
		if (model != null) {
			if (PJQ.app.session != null && model.userTypeId != null) {
				this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
			}
			else if (model.userType != null) {
				model.userTypeId = model.userType.id;
				this.userType = model.userType;
			}

			_.each(this.subItems, function (nsMap, key) {
				let modelNotificationSettings = model[key];
				if (modelNotificationSettings != null) {
					this[key] = new nsMap(modelNotificationSettings);
				}
			}, this);
		}

		return model;
	},
	beforeSave: function () {
		_.each(this.subItems, function (permMap, key) {
			let notificationSettings = this[key];
			if (notificationSettings != null && notificationSettings instanceof PJQ.models.notificationSettings.NotificationSetting) {
				this.set(key, notificationSettings.toJSON());
			}
		}, this);
	}
});

PJQ.models.notificationSettings.SystemNotificationSettings = PJQ.models.notificationSettings.NotificationSettings.extend({
	subItems: {
		projects: PJQ.models.notificationSettings.ProjectsNotifications,
		contacts: PJQ.models.notificationSettings.ContactNotifications
	},
	endpoint: function () {
		if (this.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'notificationsettings',
					value: this.id
				}
			]);
		}
		else if (this.get('id') < 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users',
					value: this.get('id')
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}
		else if (this.get('id') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.get('id')
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}
		else if (this.get('userTypeId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usertypes',
					value: this.get('userTypeId')
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'notificationsettings'
			}
		]);
	}
});

PJQ.models.notificationSettings.ProjectNotificationSettings = PJQ.models.notificationSettings.NotificationSettings.extend({
	subItems: {
		messaging: PJQ.models.notificationSettings.MessagingNotifications,
		privateMessaging: PJQ.models.notificationSettings.PrivateMessagingNotifications,
		bidForms: PJQ.models.notificationSettings.BidFormNotifications,
		drawings: PJQ.models.notificationSettings.DrawingNotifications,
		attachments: PJQ.models.notificationSettings.AttachmentNotifications,
		projectContacts: PJQ.models.notificationSettings.ProjectContactNotifications,
		rfi: PJQ.models.notificationSettings.RFINotifications,
		dailyReports: PJQ.models.notificationSettings.DailyReportNotifications,
		punchList: PJQ.models.notificationSettings.PunchListNotifications,
		submittals: PJQ.models.notificationSettings.SubmittalNotifications,
		schedule: PJQ.models.notificationSettings.ScheduleNotifications,
		actionItems: PJQ.models.notificationSettings.ActionItemNotifications,
		meetings: PJQ.models.notificationSettings.MeetingNotifications,
		payableInvoices: PJQ.models.notificationSettings.PayableInvoiceNotifications,
		commitments: PJQ.models.notificationSettings.CommitmentNotifications,
	},
	endpoint: function () {
		if (this.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'notificationsettings',
					value: this.id
				}
			]);
		}
		else if (this.get('id') != null && this.get('projectId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'contacts',
					value: this.get('id')
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}
		else if (this.get('id') < 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users',
					value: this.get('id')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}
		else if (this.get('id') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.get('id')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}
		else if (this.get('userTypeId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usertypes',
					value: this.get('userTypeId')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'notificationsettings'
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId') > 0 ? this.get('projectId') : null
			},
			{
				endpoint: 'notificationsettings'
			}
		]);
	}
});

// Views
PJQ.views.notificationSettings = {};

PJQ.views.notificationSettings.NotificationSettingsEditorModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Notification-Settings-Editor'),
		minWidth: 700
	},
	defaultEvents: {
		'click .btn-save': 'save',
		'click .btn-cancel': 'cancel'
	},
	renderData: function () {
		return {
			model: this.model,
			project: this.options.project
		};
	},
	afterRender: function () {
		this.notificationSettingsEditor = new PJQ.views.notificationSettings.NotificationSettingsEditor({
			el: this.$('.notification-settings'),
			model: this.model,
			project: this.options.project
		});
	},
	save: function () {
		new PJQ.Loader(this.$('.modal-content'));
		this.notificationSettingsEditor.save(_.bind(function () {
			this.removeModal();
			PJQ.notifications.notify.successNotify({
				message: 'Notification settings saved'
			});
		}, this));
	},
	cancel: function () {
		this.removeModal();
	}
});

PJQ.views.notificationSettings.NotificationSettingsEditor = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Notification-Settings-Editor'),
		hasTooltips: true
	},
	events: {
		'click .btn-system-notification-settings-override': 'overrideSystem',
		'click .btn-system-notification-settings-revert': 'revertSystem',
		'click .btn-project-notification-settings-override': 'overrideProject',
		'click .btn-project-notification-settings-revert': 'revertProject'
	},
	beforeFirstRender: function () {
		this.fetchNotificationSettings();
	},
	fetchNotificationSettings: function () {
		if (this.options.project != null) {
			this.fetchProjectNotificationSettings(_.bind(function () {
				this.render();
			}, this));
		}
		else {
			this.fetchSystemNotificationSettings(_.bind(function () {
				this.fetchProjectNotificationSettings(_.bind(function () {
					this.render();
				}, this));
			}, this));
		}
	},
	fetchSystemNotificationSettings: function (callback) {
		this.model.fetchSystemNotificationSettings(_.bind(function (settings) {
			this.systemNotificationSettings = settings;
			if (typeof callback === 'function') {
				callback(settings);
			}
		}, this));
	},
	fetchProjectNotificationSettings: function (callback) {
		if (this.model instanceof PJQ.models.userTypes.UserType) {
			this.model.fetchProjectNotificationSettings(_.bind(function (settings) {
				this.projectNotificationSettings = settings;
				if (typeof callback === 'function') {
					callback(settings);
				}
			}, this));
		}
		else {
			this.model.fetchProjectNotificationSettings(this.options.project ? this.options.project.id : null, _.bind(function (settings) {
				this.projectNotificationSettings = settings;
				if (typeof callback === 'function') {
					callback(settings);
				}
			}, this));
		}
	},
	renderData: function () {
		return {
			model: this.options.model,
			project: this.options.project,
			systemNotificationSettings: this.systemNotificationSettings,
			projectNotificationSettings: this.projectNotificationSettings
		};
	},
	afterRender: function () {
		let fnInit = _.bind(function (nsEl, nsModel) {
			let $nsEl = $(nsEl),
				nsKey = $nsEl.data('notificationSetting'),
				notificationSetting = nsModel[nsKey];
			if (notificationSetting != null) {
				new PJQ.Binder($nsEl, notificationSetting, {
					setDefaultValues: true,
					watchElements: [
						'input'
					],
					afterChange: _.bind(function ($ns, attr, val) {
						this.notificationSettingChanged($ns, attr, val);
						nsModel.isDirty = true;
					}, this)
				});
			}
		}, this);
		if (this.systemNotificationSettings != null) {
			_.each(this.$('.system-notification-setting-container'), function (nsEl) {
				fnInit(nsEl, this.systemNotificationSettings);
			}, this);
		}
		if (this.projectNotificationSettings != null) {
			_.each(this.$('.project-notification-setting-container'), function (nsEl) {
				fnInit(nsEl, this.projectNotificationSettings);
			}, this);
		}
	},
	notificationSettingChanged: function ($notificationSetting, attr, val) {
		let level = $notificationSetting.data('level');
		if (level != null) {
			let inputs = $notificationSetting.closest('.notification-setting-container').find('input');
			if (val && level > 1) {
				_.each(inputs, function (otherNS) {
					let $otherNS = $(otherNS),
						otherLevel = $otherNS.data('level');
					if (otherLevel != null && otherLevel < level) {
						$otherNS.prop('checked', val);
						$otherNS.trigger('change');
					}
				});
			}
			else if (!val) {
				//don't cascade notifications up if there is another permission at this level still enabled
				if (_.find(inputs, function (otherNS) {
					let otherAttr = $(otherNS).data('pBind'),
						otherLevel = $(otherNS).data('level');
					return otherLevel === level && attr !== otherAttr && $(otherNS).prop('checked');
				}) != null) {
					return;
				}
				_.each(inputs, function (otherNS) {
					let $otherNS = $(otherNS),
						otherLevel = $otherNS.data('level');
					if (otherLevel != null && otherLevel > level) {
						$otherNS.prop('checked', val);
						$otherNS.trigger('change');
					}
				});
			}
		}
	},
	overrideSystem: function () {
		//To override we have to set the correct values for an overridden notification setting
		//This will not have an id so it is temporary until saved to the server
		//When it is saved next, it POST to the correct endpoint to create the overridden notification settings
		this.systemNotificationSettings.set({
			notificationSettingsId: null,
			userTypeId: null,
			id: this.model.get('id'),
			override: true
		});
		this.render();
	},
	revertSystem: function () {
		//To revert we have to delete the overridden notification setting if it has been saved to the server already
		//We then have to fetch the inherited notification settings
		let fp = _.bind(function () {
			this.fetchSystemNotificationSettings(_.bind(function () {
				this.render();
			}, this));
		}, this);
		if (!this.systemNotificationSettings.isNew()) {
			this.systemNotificationSettings.destroy({
				success: _.bind(function () {
					this.systemNotificationSettings = null;
					fp();
				}, this)
			});
		}
		else {
			fp();
		}
	},
	overrideProject: function () {
		//To override we have to set the correct values for an overridden notification setting
		//This will not have an id so it is temporary until saved to the server
		//When it is saved next, it POST to the correct endpoint to create the overridden notification settings
		this.projectNotificationSettings.set({
			notificationSettingsId: null,
			userTypeId: null,
			id: this.model.get('id'),
			projectId: this.options.project ? this.options.project.id : null,
			override: true
		});
		this.render();
	},
	revertProject: function () {
		//To revert we have to delete the overridden notification setting if it has been saved to the server already
		//We then have to fetch the inherited notification settings
		let fp = _.bind(function () {
			this.fetchProjectNotificationSettings(_.bind(function () {
				this.render();
			}, this));
		}, this);
		if (!this.projectNotificationSettings.isNew()) {
			this.projectNotificationSettings.destroy({
				success: _.bind(function () {
					this.projectNotificationSettings = null;
					fp();
				}, this)
			});
		}
		else {
			fp();
		}
	},
	save: function (callback) {
		let fp = _.bind(function () {
				this.fetchProjectNotificationSettings(_.bind(function () {
					this.render();
				}, this));
			}, this),
			saveP = _.bind(function () {
				if (this.projectNotificationSettings != null && this.projectNotificationSettings.hasChanged()) {
					this.projectNotificationSettings.save(null, {
						success: _.bind(function () {
							if (typeof callback === 'function') {
								callback();
							}
						}, this)
					});
				}
				else {
					if (typeof callback === 'function') {
						callback();
					}
				}
			}, this);
		if (this.systemNotificationSettings != null && this.systemNotificationSettings.hasChanged()) {
			this.systemNotificationSettings.save(null, {
				success: function () {
					saveP();
					fp();
				}
			});
		}
		else {
			saveP();
		}
	}
});
